export const CSRF_COOKIE_NAME = 'XSRF-TOKEN';
